import { Injectable, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, Observable } from 'rxjs';
import { BreakpointProviderService } from '../providers/breakpoint-provider.service';
import { Breakpoint } from '../types/breakpoint';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly provider = inject(BreakpointProviderService);

  public observe(breakpoint: Breakpoint): Observable<boolean> {
    return this.breakpointObserver
      .observe(this.provider.size(breakpoint))
      .pipe(map((result) => result.matches));
  }
}
